import $ from "jquery";
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';

// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

$('.resources_slider_c38a').each(function(){
  var $element = $(this).find('.resources_slider_c38a__slider');
  var $scrollbar = $(this).find('.swiper-scrollbar');

  new Swiper($element[0], {
    slidesPerView: 1,
    watchOverflow: true,
    // If we need pagination
    scrollbar: {
      el: $scrollbar[0],
      draggable: true,
    },
    breakpoints: {
      540: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    }
  
  });
});



 
$('.resources_slider_c38a__video_plyr').each(function(){
  var $element = $(this);
  // var $video = $(this).find('video');
  // var video_aspect_ratio = ($element.attr('data-video-aspect-ratio').length) ? $element.attr('data-video-aspect-ratio') : null;


  const player = new Plyr($element[0], {
    'controls': ['play-large', 'play', 'progress', 'mute', 'volume', 'fullscreen'],
    // 'ratio' : video_aspect_ratio,
    // 'autoplay': true,
    // 'muted': true,
    // 'volume': 0
  });
});
